import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-between gap-4"
}
const _hoisted_2 = { class: "text-xs" }
const _hoisted_3 = { class: "py-4" }
const _hoisted_4 = { class: "flex items-center gap-4" }
const _hoisted_5 = { class: "text-xs" }

import { type PropType } from "vue";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronLeftIcon, ChevronRightIcon, ChevronDownIcon } from "@heroicons/vue/24/outline";

type Rows = "All" | "5 Rows" | "10 Rows" | "20 rows";


export default /*#__PURE__*/_defineComponent({
  __name: 'MinifyPagination',
  props: {
	numRows: {
		type: String as PropType<Rows>,
		required: true,
	},
	currentPage: {
		type: Number,
		default: 1,
		required: true,
	},
	lastPage: {
		type: Number,
		default: 1,
		required: true,
	},
},
  emits: ["update:page", "update:rows"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const nextPage = () => {
	if (props.lastPage === props.currentPage || props.currentPage > props.lastPage) {
		return false;
	}
	emit("update:page", props.currentPage + 1);
};

const previousPage = () => {
	if (props.currentPage <= 1) {
		return false;
	}
	emit("update:page", props.currentPage - 1);
};

const changeRows = (row: any): void => {
	emit("update:rows", row);
};

return (_ctx: any,_cache: any) => {
  return (__props.lastPage > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Menu), {
          as: "div",
          class: "relative inline-block text-left"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_unref(MenuButton), { class: "flex items-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, "Rows: " + _toDisplayString(__props.numRows), 1),
                  _createVNode(_unref(ChevronDownIcon), { class: "w-4 h-4 ml-1 cursor-pointer stroke-2 text-neutral-900" })
                ]),
                _: 1
              })
            ]),
            _createVNode(_Transition, {
              "enter-active-class": "transition duration-100 ease-out",
              "enter-from-class": "transform scale-95 opacity-0",
              "enter-to-class": "transform scale-100 opacity-100",
              "leave-active-class": "transition duration-75 ease-in",
              "leave-from-class": "transform scale-100 opacity-100",
              "leave-to-class": "transform scale-95 opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(MenuItems), { class: "absolute left-0 bottom-8 z-10 w-56 mt-2 origin-bottom-left bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_unref(MenuItem), null, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeRows(''))),
                            class: _normalizeClass([
									active ? 'bg-gray-100 text-neutral-900 font-semibold' : 'text-gray-700',
									'block px-4 py-2 text-sm cursor-pointer',
								])
                          }, "All", 2)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(MenuItem), null, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeRows(5))),
                            class: _normalizeClass([
									active ? 'bg-gray-100 text-neutral-900 font-semibold' : 'text-gray-700',
									'block px-4 py-2 text-sm cursor-pointer',
								])
                          }, "5 Rows", 2)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(MenuItem), null, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeRows(10))),
                            class: _normalizeClass([
									active ? 'bg-gray-100 text-neutral-900 font-semibold' : 'text-gray-700',
									'block px-4 py-2 text-sm cursor-pointer',
								])
                          }, "10 Rows", 2)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(MenuItem), null, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (changeRows(20))),
                            class: _normalizeClass([
									active ? 'bg-gray-100 text-neutral-900 font-semibold' : 'text-gray-700',
									'block px-4 py-2 text-sm cursor-pointer',
								])
                          }, "20 Rows", 2)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(MenuItem), null, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (changeRows(50))),
                            class: _normalizeClass([
									active ? 'bg-gray-100 text-neutral-900 font-semibold' : 'text-gray-700',
									'block px-4 py-2 text-sm cursor-pointer',
								])
                          }, "50 Rows", 2)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(MenuItem), null, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (changeRows(100))),
                            class: _normalizeClass([
									active ? 'bg-gray-100 text-neutral-900 font-semibold' : 'text-gray-700',
									'block px-4 py-2 text-sm cursor-pointer',
								])
                          }, "100 Rows", 2)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(MenuItem), null, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (changeRows(100))),
                            class: _normalizeClass([
									active ? 'bg-gray-100 text-neutral-900 font-semibold' : 'text-gray-700',
									'block px-4 py-2 text-sm cursor-pointer',
								])
                          }, "200 Rows", 2)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(__props.currentPage > 1 ? '' : 'opacity-25')
          }, [
            _createVNode(_unref(ChevronLeftIcon), {
              class: "w-4 h-4 cursor-pointer stroke-2 text-neutral-900",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (previousPage()))
            })
          ], 2),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.currentPage) + " of " + _toDisplayString(__props.lastPage), 1),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(__props.currentPage === __props.lastPage ? 'opacity-25' : '')
          }, [
            _createVNode(_unref(ChevronRightIcon), {
              class: "w-4 h-4 cursor-pointer stroke-2 text-neutral-900",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (nextPage()))
            })
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})